export default "__VITE_ASSET__fvRbf5tF__"